
import '../App.css';
import Header from '../components/Header';
import FounderPresident from '../components/FounderPresident';
import Footer from '../components/Footer';
function App() {
  return (
    <div className="App">

    <Header/> 
    <FounderPresident/>
    <Footer/>
    </div>
  );
}

export default App;
